declare global {
  interface Window {
    dataLayer: any
  }
}
/**
 * Data layer function containing various methods for updating the data layer.
 *
 * @returns data layer methods
 */
const dataLayer = () => {
  const data = window?.dataLayer || []

  type Events =
    | `view_item`
    | `begin_checkout`
    | `add_to_cart`
    | `remove_from_cart`
    | `update_quantity`

  type Parameters = Array<{
    product: any
    variant?: any
    quantity?: number
  }>

  const push = (event: Events, items: Parameters) => {
    data.push({
      event,
      ecommerce: {
        items: [
          ...items.map(({ product = {}, variant = {}, quantity = 1 }) => {
            return {
              product_id: product?.id,
              variant_id: variant?.id,
              item_name: product?.name,
              item_id: variant?.sku,
              item_variant: variant?.name,
              price: variant?.price || product?.price,
              quantity,
            }
          }),
        ],
      },
    })
  }

  console.log(`dataLayer`, data)

  return { push }
}

export default dataLayer
